module.exports = __webpack_public_path__ + "static/img/productosGlobal.702251b.png";


//////////////////
// WEBPACK FOOTER
// ./src/customization/GlobalBPOCore/assets/productosGlobal.png
// module id = Xmmp
// module chunks = 0